import { render, staticRenderFns } from "./icon-filled-heart.vue?vue&type=template&id=34e673ce&scoped=true&"
import script from "./icon-filled-heart.vue?vue&type=script&lang=js&"
export * from "./icon-filled-heart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e673ce",
  null
  
)

export default component.exports